import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, maxRating = 5, size = 16, showNumber = true, totalRatings = 0 }) => {
  const fullStars = Math.floor(rating || 0);
  const hasHalfStar = (rating || 0) % 1 >= 0.5;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <div style={{ display: 'flex', gap: '2px' }}>
        {[...Array(maxRating)].map((_, index) => {
          if (index < fullStars) {
            // Full star
            return (
              <Star
                key={index}
                size={size}
                fill="#FFB800"
                color="#FFB800"
              />
            );
          } else if (index === fullStars && hasHalfStar) {
            // Half star
            return (
              <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                <Star size={size} color="#FFB800" fill="none" />
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '50%',
                    overflow: 'hidden',
                  }}
                >
                  <Star size={size} fill="#FFB800" color="#FFB800" />
                </div>
              </div>
            );
          } else {
            // Empty star
            return (
              <Star
                key={index}
                size={size}
                color="#D1D5DB"
                fill="none"
              />
            );
          }
        })}
      </div>
      {showNumber && (
        <span style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>
          {(rating || 0).toFixed(1)}
        </span>
      )}
      {totalRatings > 0 && (
        <span style={{ fontSize: '13px', color: '#6B7280' }}>
          ({totalRatings} {totalRatings === 1 ? 'rating' : 'ratings'})
        </span>
      )}
    </div>
  );
};

export default StarRating;
